import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TempModuleService } from "./../../form-translate/services/temp-module.service";
import { DropdownConfiguration } from "dhwani-material-library";
import { DownloadDataDialogComponent } from "../download-data-dialog/download-data-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarComponent } from "dhwani-material-library";
// import { ProjectService } from "../../../../services/project/project.service";

@Component({
  selector: "app-import-forms",
  templateUrl: "./import-forms.component.html",
  styleUrls: ["./import-forms.component.css"],
  providers:[TempModuleService]
})
export class ImportFormsComponent implements OnInit {
  formsDropdownConfig: DropdownConfiguration<any> = {
    label: "Select Form",
    type: "multi",
    valueToEmit: "object",
    parentKeyToDisplay: "title",
    keyUsedForSearch: "title",
  };
  projectDropdownConfig: DropdownConfiguration<any> = {
    label: "Select Project",
    type: "single",
    valueToEmit: "object",
    parentKeyToDisplay: "name",
    keyUsedForSearch: "name",
  };
  selectFormsData: any = [];
  isProject:boolean = false
  projectList: any =[];
  projectId: any;
  disableToggle: boolean;
  isFormSubmit:boolean = false
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DownloadDataDialogComponent>,
    private manageFormServices: TempModuleService,
    private snackBar: MatSnackBar,
    // private projectService:ProjectService
  ) {
   this.isProject =  sessionStorage.getItem("projectId")?false:true
   this.disableToggle =  sessionStorage.getItem("projectId")?false:true
   if(!this.isProject){
    this.getProjectForms();
   } else{
     this.getProject();
   }
  }
  ngOnInit(): void {}
  openSnackBar(data: string[], duration) {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }

  selectForms(data) {
    this.selectFormsData = data.value;
  }
  onSubmit() {
    this.isFormSubmit = true;
    console.log(this.selectFormsData);
    let publishedFormId = this.selectFormsData.map(
      (res) => res.formId
    );
    let body = {
      destinationOrganisationId: sessionStorage.getItem("organisationId"),
      destinationProjectId: sessionStorage.getItem("projectId")?sessionStorage.getItem("projectId"):this.projectId,
      onlyPublishedFormIds: publishedFormId,
    };
    if(this.isProject){
      body['sourceProjectId'] = this.projectId;
    }
    this.manageFormServices
      .copyForms(body)
      .then((res) => {
        console.log(res);
        if (res["success"]) {
          this.isFormSubmit = false;
          this.closeDialog(true);
        }
      })
      .catch((response) => {
        this.openSnackBar([response["message"]], 2500);
        this.closeDialog(false);
        this.isFormSubmit = false;
      });
  }
  toggleChange(event){
    console.log(event);
    this.data = [];
    if(event.checked){
      this.getProject();
    } else{
    this.getProjectForms()
    }
  }
  async getProject() {
    let response;
    try {
        response = await this.manageFormServices.getProjects();
        if (response.success) {
           console.log(response);
           this.projectList = response.data;
           this.data = [];
        }
    } catch (e) {
        throw e;
    }
}
selectProject(event){
  console.log(event);
  this.projectId = event.value._id;
  if(event.value._id){
    this.getProjectForms(event.value._id)
  }
}
  getProjectForms(id='') {
    // throw new Error("Method not implemented.");
    this.manageFormServices.getForms(id).then(res=>{
      console.log(res);
      if(res['success']){
        this.data = res['data'];
      }
      
    }).catch(err=> console.log(err))
  }
  closeDialog(flag = false) {
    this.dialogRef.close(flag);
  }
}
